import { useContext, useEffect, useState } from 'react';
import { AppHeader, Typography } from '@ace-clublabs/shared-component-library';
import { MembershipAppStateContext } from '../components/MembershipAppState/MembershipAppState';
import { LoadingIndicator } from '../components/LoadingIndicator';
import CookieHelper from '../utils/cookieHelper';
import { UtagHelper, UtagType } from '../utils/UtagHelper';

export const LandingPage: React.FC = () => {
  const { loadingInfo, setZipCouponCampaignCodeAndFlowType, sendTag } = useContext(MembershipAppStateContext);
  const zipCodeFromCookie = CookieHelper.getZipcodeFromZipcodeCookie();
  const urlParams = new URLSearchParams(window.location.search);
  const campaignCodeFromCookie = CookieHelper.getCampaignCodeFromCookie();
  const zipCodeFromUrl: string | null = urlParams.get('zipcode') ?? null;
  const couponCode: string | null = urlParams.get('couponcode') ?? null;
  const campaignCode: string | null =
    urlParams.get('campaigncode') ?? urlParams.get('campaignCode') ?? campaignCodeFromCookie ?? null;
  const zipParam = urlParams.get('zip') ?? null;
  const assignZipCodeCookie = zipParam && zipParam !== zipCodeFromCookie;
  const flowType: string | null = urlParams.get('flow') ? (urlParams.get('flow')?.toUpperCase() ?? null) : null;
  const employeeId: string | null = urlParams.get('empid') ?? null;

  const addZipRouter = () => {
    const zipRouterScript = document.createElement('script');
    zipRouterScript.src = 'https://app.ace.aaa.com/zip-router/ace-zip-router-1.0.3.js';
    zipRouterScript.type = 'text/javascript';
    zipRouterScript.id = 'zip-router-modal-script';
    document.body.appendChild(zipRouterScript);
  };

  useEffect(() => {
    const zipCode = zipCodeFromUrl || zipCodeFromCookie;

    const zipCodeRouterListener = () => {
      const updatedZipCodeFromCookie = CookieHelper.getZipcodeFromZipcodeCookie();
      setZipCouponCampaignCodeAndFlowType(
        updatedZipCodeFromCookie,
        couponCode,
        campaignCode,
        flowType,
        window.location.search,
        employeeId
      );
    };

    if (!zipCode) {
      sendTag(UtagType.view, 'select level');
    }

    if (!zipCode || assignZipCodeCookie) {
      document.addEventListener('zipRouteUpdate', zipCodeRouterListener);
      document.addEventListener('zipCodeUpdatedEvent', zipCodeRouterListener);

      addZipRouter();
      return () => {
        document.removeEventListener('zipRouteUpdate', zipCodeRouterListener);
        document.removeEventListener('zipCodeUpdatedEvent', zipCodeRouterListener);
      };
    }

    setZipCouponCampaignCodeAndFlowType(
      zipCode,
      couponCode,
      campaignCode,
      flowType,
      window.location.search,
      employeeId
    );
  }, []);

  const currentStep = loadingInfo.loadingDetails.length;
  return loadingInfo.isLoading ? (
    <>
      <AppHeader sx={{ padding: 0 }} />
      <LoadingIndicator loadingInfo={loadingInfo} maxSteps={2} currentStep={currentStep} displaySteps={1} />
    </>
  ) : (
    <>
      <AppHeader sx={{ padding: 0 }} />
    </>
  );
};
